/* ==========================================================================
   TSR — Build Your Own Mini Trio (mix & match minis)
   Selection logic + AJAX add-to-cart. Stores picks as line-item properties
   (Pick 1..N) so they show in the cart drawer / cart / checkout and on the
   order. Reuses Dawn globals (fetchConfig, routes, publish, PUB_SUB_EVENTS,
   the cart-notification / cart-drawer element) with safe fallbacks.
   ========================================================================== */
(function () {
  'use strict';

  function initBuilder(root) {
    var picks = parseInt(root.getAttribute('data-picks'), 10) || 3;
    var variantId = root.getAttribute('data-variant-id');
    var options = Array.prototype.slice.call(root.querySelectorAll('[data-bb-option]'));
    var slots = Array.prototype.slice.call(root.querySelectorAll('[data-bb-slot]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.tsr-bb__dot'));
    var countEl = root.querySelector('[data-bb-count]');
    var addBtn = root.querySelector('[data-bb-add]');
    var hintEl = root.querySelector('[data-bb-hint]');
    var errorEl = root.querySelector('[data-bb-error]');
    var liveEl = root.querySelector('[data-bb-live]');
    var trayEl = root.querySelector('.tsr-bb__tray');
    if (!addBtn || !variantId || options.length === 0) return;

    var selected = []; // [{ name, img }]

    function announce(msg) { if (liveEl) liveEl.textContent = msg; }

    function indexOfName(name) {
      for (var i = 0; i < selected.length; i++) {
        if (selected[i].name === name) return i;
      }
      return -1;
    }

    function removeByName(name) {
      var i = indexOfName(name);
      if (i === -1) return;
      selected.splice(i, 1);
      announce(name + ' removed. ' + selected.length + ' of ' + picks + ' selected.');
      render();
    }

    function buildSlot(slot, index) {
      var fill = slot.querySelector('.tsr-bb__slot-fill');
      if (!fill) return;
      var pick = selected[index];
      while (fill.firstChild) { fill.removeChild(fill.firstChild); }

      if (!pick) {
        slot.classList.remove('is-filled');
        var empty = document.createElement('span');
        empty.className = 'tsr-bb__slot-empty';
        empty.textContent = 'Pick ' + (index + 1);
        fill.appendChild(empty);
        return;
      }

      slot.classList.add('is-filled');
      if (pick.img) {
        var img = document.createElement('img');
        img.className = 'tsr-bb__slot-thumb';
        img.src = pick.img;
        img.alt = '';
        img.setAttribute('aria-hidden', 'true');
        img.width = 36;
        img.height = 36;
        fill.appendChild(img);
      }
      var nm = document.createElement('span');
      nm.className = 'tsr-bb__slot-name';
      nm.textContent = pick.name;
      fill.appendChild(nm);

      var rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'tsr-bb__slot-remove';
      rm.setAttribute('aria-label', 'Remove ' + pick.name);
      rm.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M2.8 2.8l10.4 10.4M13.2 2.8L2.8 13.2" stroke="currentColor" stroke-width="1.7" fill="none" stroke-linecap="round"/></svg>';
      rm.addEventListener('click', function () { removeByName(pick.name); });
      fill.appendChild(rm);
    }

    function render() {
      var count = selected.length;

      options.forEach(function (opt) {
        var on = indexOfName(opt.getAttribute('data-name')) !== -1;
        opt.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      root.classList.toggle('is-full', count >= picks);

      slots.forEach(buildSlot);
      dots.forEach(function (dot, i) { dot.classList.toggle('is-on', i < count); });
      if (countEl) countEl.textContent = String(count);

      var ready = count === picks;
      addBtn.setAttribute('aria-disabled', ready ? 'false' : 'true');
      if (ready) { addBtn.removeAttribute('disabled'); } else { addBtn.setAttribute('disabled', 'disabled'); }

      if (hintEl) {
        hintEl.classList.remove('is-warn');
        if (ready) {
          hintEl.textContent = 'Looks delicious — add it to your cart!';
        } else {
          var left = picks - count;
          hintEl.textContent = 'Pick ' + left + ' more flavor' + (left === 1 ? '' : 's') + ' to continue.';
        }
      }
    }

    function toggleOption(opt) {
      var name = opt.getAttribute('data-name');
      if (indexOfName(name) !== -1) { removeByName(name); return; }
      if (selected.length >= picks) {
        if (hintEl) { hintEl.classList.add('is-warn'); hintEl.textContent = "That's " + picks + '! Remove one to swap.'; }
        announce('You can only choose ' + picks + '. Remove one to swap.');
        return;
      }
      selected.push({ name: name, img: opt.getAttribute('data-img') || '' });
      announce(name + ' added. ' + selected.length + ' of ' + picks + ' selected.');
      render();
      if (selected.length === picks) maybeScrollTray();
    }

    function reset() { selected = []; render(); }

    // On the pick that completes the trio, bring the tray into view on mobile
    // (desktop keeps it beside the grid). Skips if already visible; respects reduced motion.
    function maybeScrollTray() {
      if (!trayEl) return;
      if (window.matchMedia && window.matchMedia('(min-width: 990px)').matches) return;
      var r = trayEl.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (r.top >= 0 && r.bottom <= vh) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try { trayEl.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }
      catch (e) { trayEl.scrollIntoView(); }
    }

    function setLoading(on) {
      addBtn.classList.toggle('is-loading', on);
      var spinner = addBtn.querySelector('.tsr-bb__add-spinner');
      if (spinner) spinner.hidden = !on;
      if (on) addBtn.setAttribute('aria-disabled', 'true');
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.hidden = false;
      errorEl.textContent = msg || 'Something went wrong. Please try again.';
    }
    function clearError() { if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; } }

    function submit() {
      clearError();
      setLoading(true);

      var cartUI = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      selected.forEach(function (s, i) {
        formData.append('properties[Pick ' + (i + 1) + ']', s.name);
      });

      var config;
      if (typeof fetchConfig === 'function') {
        config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
      } else {
        config = { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } };
      }

      if (cartUI && typeof cartUI.getSectionsToRender === 'function') {
        formData.append('sections', cartUI.getSectionsToRender().map(function (s) { return s.id; }));
        formData.append('sections_url', window.location.pathname);
        if (typeof cartUI.setActiveElement === 'function') {
          cartUI.setActiveElement(document.activeElement);
        }
      }
      config.body = formData;

      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

      fetch(addUrl, config)
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (data && data.status) {
            showError(data.description || data.message);
            return;
          }
          if (cartUI) {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tsr-bundle-builder', productVariantId: variantId, cartData: data });
            }
            if (cartUI.classList.contains('is-empty')) cartUI.classList.remove('is-empty');
            if (typeof cartUI.renderContents === 'function') {
              cartUI.renderContents(data);
            } else if (typeof cartUI.open === 'function') {
              cartUI.open();
            }
            reset();
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () { showError('Could not add to cart. Please try again.'); })
        .finally(function () { setLoading(false); render(); });
    }

    options.forEach(function (opt) {
      opt.addEventListener('click', function () { toggleOption(opt); });
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-bb-preset]'), function (btn) {
      btn.addEventListener('click', function () {
        var names = (btn.getAttribute('data-flavors') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        selected = [];
        names.forEach(function (nm) {
          if (selected.length >= picks) return;
          var low = nm.toLowerCase();
          for (var i = 0; i < options.length; i++) {
            var on = options[i].getAttribute('data-name');
            if (on && on.toLowerCase() === low && indexOfName(on) === -1) {
              selected.push({ name: on, img: options[i].getAttribute('data-img') || '' });
              break;
            }
          }
        });
        announce('Loaded ' + (btn.textContent || '').trim() + '. ' + selected.length + ' of ' + picks + ' selected.');
        render();
      });
    });

    addBtn.addEventListener('click', function () {
      if (addBtn.getAttribute('aria-disabled') === 'true') return;
      submit();
    });

    render();
  }

  function init() {
    var roots = document.querySelectorAll('[data-tsr-bundle-builder]');
    Array.prototype.forEach.call(roots, function (root) { initBuilder(root); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
